var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('product-form',{attrs:{"loading":_vm.loading,"productData":_vm.product,"formErrors":_vm.formErrors},on:{"productSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }